import { Injectable } from '@angular/core'
import * as moment from 'moment'
import * as numeral from 'numeral'
import { BaseService } from './base.service'

@Injectable()
export class UtilsService extends BaseService {

  constructor() {
    super()
    try {
      numeral.register('locale', 'it', {
          delimiters: {
              thousands: '.',
              decimal: ','
          },
          abbreviations: {
              thousand: 'mila',
              million: 'mil',
              billion: 'b',
              trillion: 't'
          },
          ordinal: function (number) {
              return 'º';
          },
          currency: {
              symbol: '€'
          }
      })
      numeral.locale('it')
    } catch(e) {

    }
  }

  formatDate (value: any) {
    const m = moment(value)
    return m.isValid() ? m.format('DD/MM/YYYY') : value
  }

  formatTime (value: any) {
    const m = moment(value)
    return m.isValid() ? m.format('HH:mm:ss') : value
  }

  formatDateTime (value: any) {
    const m = moment(value)
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : value
  }

  formatCurrency (value: any) {
    const c = numeral(value).format('0,0.00')
    return c === 'NaN' ? numeral(0).format('0,0.00') : c
  }

  formatCurrencyEmpty (value: any) {
    const c = numeral(value).format('0,0.00')
    return value ? (c === 'NaN' ? '-' : c) : '-'
  }

  formatInteger (value: any) {
    const c = numeral(value).format('0,0')
    return c === 'NaN' ? numeral(0).format('0,0') : c
  }

  formatNumber (value: any) {
    return numeral(value).format('0,0.00')
  }

  formatPercentage (value: any) {
    return numeral(value).format('0%')
  }

  formatTons (value: any) {
    return numeral(value).format('0,0.0000')
  }

}
